<div class="fix-perimeter" style="max-height: 125px; position: relative;">
  <button
    class="btn btn-light"
    style="position: absolute; left: 10px; top: 10px; z-index: 1000;"
    (click)="onCancelClicked()">
    <span><i class="fa fa-times"></i></span>
  </button>
  <div id="showSetFocalPoint" [hidden]="showAddFocalPoint">
    <div style="width: 270px; margin: 0 auto;" class="mt-2">
      <button
        (click)="setFocalPointButtonClicked()"
        class="btn btn-light me-2"
        style="display: inline-block; width: 130px; height: 75px;">
        <span><img src="assets/img/glyphicons/glyphicons-239-pin.png"></span>
        <br>
        {{ focalPointText }}
      </button>
      <button
        (click)="continueButtonClicked()"
        class="btn btn-success"
        style="display: inline-block; width: 130px; height: 75px;">
        <span><img src="assets/img/glyphicons/glyphicons-212-arrow-right.png"></span>
        <br>
        Continue
      </button>
    </div>
    <div [innerHTML]="focalPointDivMessage" class="help-text"></div>
  </div>
  <div id="showAddFocalPoint" [hidden]="!showAddFocalPoint">
    <div style="width: 100px; margin: 0 auto;">
      <button
        (click)="cancelFocalPointClicked()"
        class="btn btn-danger"
        style="display: inline-block; width: 75px;">
        <span><i class="indicator glyphicon glyphicon-remove"></i></span>
        <br>
        Cancel
      </button>
    </div>
    <div class="help-text">Click anywhere on the globe to set the focal point.</div>
  </div>
</div>
